module.exports = __webpack_public_path__ + "img/xiaofei@2x.78d5f722.png";